/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { Dropdown } from 'ember-basic-dropdown/addon/components/basic-dropdown';
import { FlyActionDropdownItem } from '@customerio/fly-components/addon/components/fly-action-dropdown';
import { action } from '@ember/object';
import Clipboard from 'clipboard';
import { tracked } from '@glimmer/tracking';
import ProfileShortcutModel, { RenderedProfileShortcut } from 'cio/models/profile-shortcut';
import ApiService from 'cio/services/api';
import CustomerModel from 'cio/models/customer';
import AlertsService from 'cio/services/alerts';
import MasqService from 'cio/services/masq';
import AnalyticsService from 'cio/services/analytics';

interface ShortcutItemArgs {
  renderedShortcut: RenderedProfileShortcut;
  originalShortcut: ProfileShortcutModel;
  customer: CustomerModel;
  dropdown: Dropdown;
  showEditModal: (shortcutId: string) => unknown;
  showDeleteModal: (shortcutId: string) => unknown;
  sendWebhook: (shortcut: RenderedProfileShortcut) => unknown;
  refreshShortcuts: () => unknown;
}

export default class ShortcutItem extends Component<ShortcutItemArgs> {
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;
  @service api!: ApiService;
  @service masq!: MasqService;

  get dropdownOptions(): FlyActionDropdownItem[] {
    return [
      {
        label: 'Edit',
        action: this.showEditModal,
      },
      {
        label: 'Delete',
        action: this.showDeleteModal,
      },
    ];
  }

  get hasRenderError() {
    return (this.args.renderedShortcut.render_errors ?? []).length > 0;
  }

  copyLinkButton: HTMLButtonElement | null = null;
  clipboard: Clipboard | null = null;

  @tracked isShowingEditModal = false;
  @tracked isShowingDeleteModal = false;

  @tracked isShowingSendWebhookModal = false;

  @action
  sendWebhook() {
    this.trackClick();
    this.args.sendWebhook(this.args.renderedShortcut);
    this.args.dropdown.actions.close();
  }

  @action
  showEditModal() {
    this.args.showEditModal(this.args.renderedShortcut.id);
    this.args.dropdown.actions.close();
  }

  @action
  showDeleteModal() {
    this.args.showDeleteModal(this.args.renderedShortcut.id);
    this.args.dropdown.actions.close();
  }

  @action
  didInsertCopyLinkButton(button: HTMLButtonElement) {
    this.copyLinkButton = button;

    this.clipboard = new Clipboard(button, {
      text: () => {
        return this.args.renderedShortcut.url;
      },
    });
  }

  @action
  willDestroyCopyLinkButton() {
    this.clipboard?.destroy();
    this.clipboard = null;
    this.copyLinkButton = null;
  }

  @action
  trackClick() {
    this.analytics.track('shortcuts', 'clicked', {
      shortcut: this.args.originalShortcut,
    });
  }
}
